export const genericUpsellOptionsDefault = {
    modal: {
        background: '',
        title: '',
        copy: undefined,
    },
    price: undefined,
    priceSuffix: undefined,
    icon: undefined,
    card: {
        background: '',
        title: '',
    },
    type: 'simple-form',
    buttonText: 'Add to Booking',
    submissionTarget: '/basket',
};
